<script setup>
// Barra sobre o item selecionado: subir/descer, duplicar, copiar, salvar como
// bloco, excluir e "selecionar a linha". Rodapé não sai, não duplica e não vira
// bloco.
import { computed, inject } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  nodeId: { type: String, required: true },
  kind: { type: String, required: true },
  locked: { type: Boolean, default: false },
});
const ed = inject('emailEditor');
const { t } = useI18n();
const found = computed(() => ed.selected.value);
const inFooter = computed(() => found.value?.row?.role === 'footer');

const move = delta => {
  const f = found.value;
  if (!f) return;
  if (props.kind === 'row') ed.moveRow(props.nodeId, f.rowIndex + delta);
  else ed.moveElement(props.nodeId, f.column.id, f.elIndex + delta);
};
const ACTIONS = computed(() =>
  [
    {
      key: 'up',
      icon: 'i-lucide-arrow-up',
      label: 'MOVE_UP',
      run: () => move(-1),
      hide: props.locked,
    },
    {
      key: 'down',
      icon: 'i-lucide-arrow-down',
      label: 'MOVE_DOWN',
      run: () => move(1),
      hide: props.locked,
    },
    {
      key: 'parent',
      icon: 'i-lucide-square-dashed',
      label: 'PARENT',
      run: () => ed.selectParent(),
      hide: props.kind === 'row',
    },
    {
      key: 'dup',
      icon: 'i-lucide-copy-plus',
      label: 'DUPLICATE',
      run: () => ed.duplicate(props.nodeId),
      hide: props.locked,
    },
    {
      key: 'copy',
      icon: 'i-lucide-clipboard-copy',
      label: 'COPY',
      run: () => ed.copy(props.nodeId),
      hide: props.locked,
    },
    {
      key: 'save',
      icon: 'i-lucide-bookmark-plus',
      label: 'SAVE_BLOCK',
      run: () => ed.requestSaveBlock(props.nodeId),
      hide: props.locked || inFooter.value,
    },
    {
      key: 'del',
      icon: 'i-lucide-trash-2',
      label: 'DELETE',
      run: () => ed.remove(props.nodeId),
      hide: props.locked,
    },
  ].filter(a => !a.hide)
);
</script>

<template>
  <div
    class="flex items-center gap-0.5 rounded-lg bg-n-brand p-0.5 text-white shadow-md"
    @click.stop
    @mousedown.stop
  >
    <span v-if="locked" class="px-2 text-[11px]">{{
      t('EMAIL_TEMPLATES.EDITOR.TOOLBAR.FOOTER_LOCKED')
    }}</span>
    <button
      v-for="a in ACTIONS"
      :key="a.key"
      type="button"
      class="rounded-md p-1 hover:bg-white/20"
      :title="t(`EMAIL_TEMPLATES.EDITOR.TOOLBAR.${a.label}`)"
      @click="a.run()"
    >
      <span :class="a.icon" class="block size-4" />
    </button>
  </div>
</template>
